export const reportOaConstants={
    GET_REPORT_OA: "GET_REPORT_OA_LIST",
    GET_REPORT_OA_SUCCESS: "GET_REPORT_OA_LIST_SUCCESS",
    GET_REPORT_OA_FAILURE: "GET_REPORT_OA_LIST_FAILURE",
}